import TextTheme from '../Text/Text.theme';

const schemeColors = {
  default: { color: 'inherit', hover: 'inherit' },
  gray: { color: 'neutral.70', hover: 'neutral.50' },
  purple: { color: 'purple.50', hover: 'purple.30' },
  white: { color: 'neutral.100', hover: 'neutral.95' },
};

const LinkTheme = {
  baseStyle: ({ colorScheme: c, textStyle }: { colorScheme?: 'purple' | 'white' | 'gray'; textStyle?: string }) => {
    const { color, hover } = schemeColors[c || 'default'];
    return {
      _focus: {
        outline: 'none',
      },
      _hover: {
        color: hover,
      },
      color,
      fontSize: textStyle ? undefined : 'inherit',
    };
  },
  ...TextTheme,
};

export default LinkTheme;
